import { useGlobalAuth } from '@r-client/shared/data/auth';
import { E_REGION } from '@r-client/shared/feature/region';

import {
  getJurisdictionAccounts,
  hasAccountInRegion,
  IJurisdictionAccounts,
} from '../utils/jurisdiction';

export interface IUseJurisdictionResult {
  isAuthenticated: boolean;
  accounts: IJurisdictionAccounts;
  hasAccountInRegion: (region: E_REGION) => boolean;
}

/**
 * Returns global auth status and jurisdiction account presence for the current user.
 *
 * - `isAuthenticated`: whether the user has an active global auth session
 * - `accounts`: which jurisdiction accounts exist (`hasUsAccount`, `hasEuAccount`, `hasUkAccount`)
 * - `hasAccountInRegion(region)`: convenience helper (EUROPE includes UK)
 */
export const useJurisdiction = (): IUseJurisdictionResult => {
  const globalAuth = useGlobalAuth();
  const viewer = globalAuth.viewer;
  const isAuthenticated = viewer?.isAuthenticated === true;
  const accounts = getJurisdictionAccounts(viewer);

  return {
    isAuthenticated,
    accounts,
    hasAccountInRegion: (region: E_REGION) =>
      hasAccountInRegion(viewer, region),
  };
};
